import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import AOS from "aos";
import "./ProjectsStyle.css";
import img1 from "../../assets/img1.png";
import img2 from "../../assets/img2.png";
import img3 from "../../assets/img3.png";
import img4 from "../../assets/img4.png";
import img5 from "../../assets/img5.png";
import img6 from "../../assets/img6.png";

const Projects = ({ id }) => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const animateCounter = (element, end, duration) => {
    let start = 0;
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      start = Math.floor(progress * end);
      element.textContent = `+${start}`;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: true,
    });

    const section = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const counters = entry.target.querySelectorAll(".counter");
            counters.forEach((counter) => {
              const endValue = parseInt(counter.getAttribute("data-end"));
              if (!counter.classList.contains("counted")) {
                animateCounter(counter, endValue, 2000);
                counter.classList.add("counted");
              }
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: [0.1, 0.5] }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section id={id} className="projects-section" ref={sectionRef}>
      <div className="projects-content">
        <h2 data-aos="fade-up" data-aos-offset="200">
          {t("projects.title")}
        </h2>
        <div className="projects-grid">
          <div
            className="project-item project-stats"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <h3 className="counter" data-end="100">
              +0
            </h3>
            <p>{t("projects.completed")}</p>
          </div>
          <div
            className="project-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <img src={img1} alt="Modern Residential Building" />
          </div>

          <div
            className="project-item project-stats"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <h3 className="counter" data-end="30">
              +0
            </h3>
            <p>{t("projects.employees")}</p>
          </div>
          <div
            className="project-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <img src={img2} alt="Luxury Interior Design" />
          </div>

          <div
            className="project-item project-stats"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <h3 className="counter" data-end="9">
              +0
            </h3>
            <p>{t("projects.experience")}</p>
          </div>
          <div
            className="project-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <img src={img3} alt="Architectural Skyscraper" />
          </div>

          <div
            className="project-item project-stats"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <h3 className="counter" data-end="100">
              +0
            </h3>
            <p>{t("projects.clients")}</p>
          </div>
          <div
            className="project-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <img src={img4} alt="Commercial Complex" />
          </div>

          <div
            className="project-item project-stats"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <h3 className="counter" data-end="100">
              +0
            </h3>
            <p>{t("projects.reviews")}</p>
          </div>
          <div
            className="project-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <img src={img5} alt="Sustainable Design Project" />
          </div>

          <div
            className="project-item project-stats"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <h3 className="counter" data-end="30">
              +0
            </h3>
            <p>{t("projects.ongoing")}</p>
          </div>
          <div
            className="project-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <img src={img6} alt="Collaborative Project" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
